import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Spinner,
} from "reactstrap";
import ModalConID from "../ModalConID";
import { useInsertConText } from "../../Context/InsertContext";
import ModalUser from "../SetCommander/ModalUser";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import {
  FetchAxiosFile,
  FetchAxiosGet,
  FetchAxiosPost,
  FetchAxiosPut,
} from "../../../api/axios";
import ModalAssignUser from "../SetCommander/ModalAssignUser";
import LoadingData from "../../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import MyThaiDatePick from "../../../components/Common/ThaiDatePicker";
import ConfirmModal from "../../../components/Common/ConfirmModal";

const API_URL = process.env.REACT_APP_API_CORS;

function EditAssignCommander(props) {
  const { onButtonClick, id } = props;
  const { insert, setInsert } = useInsertConText();
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState(null);
  const [userID, setUserID] = useState(null);
  const [userAssignName, setUserAssignName] = useState(null);
  const [userAssignID, setUserAssignID] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState(null);
  const [position_Name, setPosition_Name] = useState(null);
  const [position_ID, setPosition_ID] = useState(null);
  const [userAssignData, setUserAssignData] = useState(null);
  const [userAssignDataOrg, setUserAssignDataOrg] = useState(null);
  const [assignId, setAssignId] = useState(null);
  const [assignUserId, setAssignUserId] = useState(null);
  const [assignOrgName, setAssignOrgName] = useState(null);
  const [fileUp, setFileUp] = useState(null);
  const [masterdata, setMasterdata] = useState([]);

  const [userEditData, setUserEditData] = useState([]);
  const [editIDData, setEditIDData] = useState(null);
  const [editIDUser, setEditIDUser] = useState(null);
  const [currentPositionID, setCurrentPositionID] = useState(null);
  const [editNamePosition, setEditNamePosition] = useState(null);
  const [assignOrg, setAssignOrg] = useState(null);
  const [assignUserID, setAssignUserID] = useState(null);
  const [editStartDate, setEditStartDate] = useState(null);
  const [editEndDate, setEditEndDate] = useState(null);
  const [editStatus, setEditStatus] = useState(null);
  const [editID, setEditID] = useState(null);
  const [editOrgName, setEditOrgName] = useState(null);
  const [EditFile, setEditFile] = useState(null);
  const [EditPosition_ID, setEditPosition_ID] = useState(null);
  const [EditPosition_Name, setEditPosition_Name] = useState(null);

  const [orgId, setOrgId] = useState(null);
  const [orgName, setOrgName] = useState(null);

  const [org, setOrg] = useState(null);
  const [alertStartDate, setAlertStartDate] = useState(false);

  const [confirmModal, setconfirmModal] = useState(false);

  const token = GetCookieToken("userToken");
  const positionURL = `/api/users/position/${id}`;

  // ─── fetch functions ──────────────────────────────

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/config/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMasterdata(response.data.result);
    } catch (error) {
      console.error("fetchMasterData Error:", error);
    }
  };

  const fetchData = async () => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "position_id",
      "order[1]": "ASC",
      "filter[id][0]": id,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      const result = response.data.result;
      setUserEditData(result);
      setEditIDUser(result?.map(i => i.user_id));
      setAssignUserID(result?.map(i => i.assigned_by_user_id));
      setEditStartDate(result?.map(i => i.date_start));
      setEditEndDate(result?.map(i => i.date_end));
      setEditIDData(result?.map(i => i.org_id));
      setEditStatus(result?.map(i => i.status));
      setEditFile(result?.map(i => i.assign_doc?.split("public/")[1]));
      setEditID(result?.map(i => i.assign_org_id));
      setEditPosition_ID(result?.map(i => i.position_id));
      setEditPosition_Name(result?.map(i => i.position_name));
    } catch (error) {
      console.error("fetchData Error:", error);
    }
  };

  const fetchUserData = async (id) => {
    if (id === null) return;
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "position_id",
      "order[1]": "ASC",
      "filter[user_id][0]": id,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      setUserAssignData(response.data.result);
    } catch (error) {
      console.error("fetchUserData Error:", error);
    }
  };

  const fetchOrgIdData = async (assign_id, id) => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "position_id",
      "order[1]": "ASC",
      "filter[id][0]": assign_id,
      "filter[user_id][0]": id,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      setUserAssignDataOrg(response.data.result);
    } catch (error) {
      console.error("fetchOrgIdData Error:", error);
    }
  };

  const fetchDataUser = async (id, setValue) => {
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "user_name",
      "order[1]": "ASC",
      "filter[user_id][0]": id,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      setValue(() => response.data.result?.map(i => i.user_name));
    } catch (error) {
      console.error("fetchDataUser Error:", error);
    }
  };

  const fetchDataAssignUser = async (id, setValue) => {
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "user_name",
      "order[1]": "ASC",
      "filter[user_id][0]": id,
    });
    const config = { headers: { Authorization: `Bearer ${token}` }, params };
    try {
      const response = await axios.get(url, config);
      setValue(() => response.data.result?.map(i => i.user_name));
    } catch (error) {
      console.error("fetchDataAssignUser Error:", error);
    }
  };

  // ─── toggle handlers ─────────────────────────────────────────────────────────

  const toggleRightCanvasT = async () => {
    setLoading(true);
    setUserAssignName(null);
    setUserAssignID(null);
    setAssignUserId(null);
    setUserID(null);
    setUserName(null);
    setOrgId(null);
    setOrgName(null);
    setOpen(prev => !prev);

    await Promise.all([fetchMasterData(), fetchData()]);
    setLoading(false);
  };

  const toggleRightCanvasF = async () => {
    setLoading(true);
    await onButtonClick();
    setOpen(prev => !prev);
    setLoading(false);
  };

  const toggleRightCanvasFS = async () => {
    setLoading(true);
    handleClearFile();
    setUserAssignName(null);
    setUserAssignID(null);
    setAssignUserId(null);
    setUserID(null);
    setUserName(null);
    setUserAssignDataOrg(null);
    setUserAssignData(null);
    setAssignId(null);
    setLoading(false);
    setOpen(prev => !prev);
  };

  // ─── submit ──────────────────────────────────────────────────────────────────

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async () => {
    const data = {
      position_id: currentPositionID ?? EditPosition_ID[0],
      position_name: editNamePosition ?? EditPosition_Name[0],
      user_id: userID !== null ? userID : `${editIDUser}`,
      is_default: 0,
      date_start: startDate ? startDate : `${editStartDate}`,
      date_end: endDate ? endDate : `${editEndDate}`,
      org_id: orgId,
      assign_org_id: orgId,
      status: status !== null ? status : `${editStatus}`,
      assign: 1,
    };
    if (status === 1) {
      data.date_end = null;
    } else if (status === 0) {
      data.date_end = endDate ? endDate : getCurrentDate();
    }

    setLoading(true);
    await FetchAxiosPut(positionURL, data, token);
    setUserAssignName(null);
    setUserAssignID(null);
    setAssignUserId(null);
    setUserID(null);
    setUserName(null);
    setUserAssignDataOrg(null);
    setUserAssignData(null);
    setAssignId(null);
    await toggleRightCanvasF();
    setLoading(false);
  };

  // ─── useEffects ──────────────────────────────────────────────────────────────

  useEffect(() => {
    const checkNlv = assignOrg?.find(i => i.org_id == orgId);
    if (checkNlv?.nodelv == 1) {
      setCurrentPositionID(2);
      setEditNamePosition("เลขาธิการ ก.พ.ร.");
    } else if (checkNlv?.nodelv == 2) {
      setCurrentPositionID(5);
      setEditNamePosition("ผู้อำนวยการกอง");
    } else if (checkNlv?.nodelv == 3) {
      setCurrentPositionID(7);
      setEditNamePosition("ผู้เชี่ยวชาญกลุ่ม/หัวหน้ากลุ่ม");
    }
  }, [orgId]);

  useEffect(() => {
    setEditOrgName(assignOrg?.find(i => i.org_id == editIDData)?.org_name);
  }, [assignOrg, editIDData]);

  useEffect(() => {
    if (insert.task === "สำนัก/กอง/กลุ่ม_ผู้บังคับบัญชา") {
      setOrgId(insert.insert_id);
      setOrgName(insert.insert_name);
    }
    if (insert.task === "user_ผู้บังคับบัญชา") {
      setUserID(insert.insert_id);
      setUserName(insert.insert_name);
    }
    if (insert.task === "Assign_ผู้บังคับบัญชา") {
      setUserAssignName(insert.insert_name);
      setUserAssignID(insert.insert_id);
    }
  }, [insert]);

  useEffect(() => {
    if (userAssignID !== null) {
      setLoading(true);
      setUserAssignDataOrg(null);
      fetchUserData(userAssignID).finally(() => setLoading(false));
    }
  }, [userAssignID]);

  useEffect(() => {
    if (assignId !== null) {
      setLoading(true);
      fetchOrgIdData(assignId, userAssignID).finally(() => setLoading(false));
    }
  }, [assignId]);

  useEffect(() => {
    if (editIDUser !== null) {
      fetchDataUser(editIDUser, setUserName);
    }
  }, [editIDUser]);

  useEffect(() => {
    if (assignUserID !== null) {
      setLoading(true);
      Promise.all([
        fetchDataAssignUser(assignUserID, setUserAssignName),
        fetchUserData(assignUserID),
      ]).finally(() => setLoading(false));
    }
  }, [assignUserID]);

  useEffect(() => {
    if (editID !== null) {
      setLoading(true);
      fetchOrgIdData(editID.toString(), assignUserID).finally(() =>
        setLoading(false)
      );
    }
  }, [editID]);

  useEffect(() => {
    if (userAssignData !== null) {
      const configPoID = userAssignDataOrg?.map(assign => assign.position_id);
      const foundData = masterdata.users_position?.find(
        i => i.users_position_id === parseInt(configPoID)
      );
      setPosition_ID(foundData?.users_position_id);
      setPosition_Name(foundData?.users_position_name);
    }
  }, [userAssignDataOrg]);

  // โหลด assignOrg ครั้งเดียวตอน mount
  useEffect(() => {
    const url = `${API_URL}/api/orgInner/level`;
    const config = { headers: { Authorization: `Bearer ${token}` } };
    axios
      .get(url, config)
      .then(response => {
        const allNodelv = [];
        allNodelv.push(response.data.result);
        response.data.result.child.map((item) => {
          allNodelv.push(item);
          item.child.map((subItem) => {
            allNodelv.push(subItem);
            subItem.child.map((sublv3) => {
              allNodelv.push(sublv3);
            });
          });
        });
        setAssignOrg(allNodelv);
      })
      .catch(error => console.error("fetchOrgLevel Error:", error));
  }, []);

  // ─── file handlers ───────────────────────────────────────────────────────────

  const handleButtonFileClick = () => {
    document.getElementById("file-input")?.click();
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) setFileUp(file);
  };

  const handleClearFile = () => {
    const fileInput = document.getElementById("file-input");
    if (fileInput) fileInput.value = null;
    setFileUp(null);
  };

  // ─── render ──────────────────────────────────────────────────────────────────

  return (
    <Fragment>
      <ConfirmModal
        modal={confirmModal}
        modalSize="md"
        modalHeaderContent="คุณต้องการที่จะแก้ไข ใช่หรือไม่?"
        onClickConfirmBtn={() => {
          handleSubmit();
          setconfirmModal(false);
        }}
        onClickCancelBtn={() => setconfirmModal(false)}
      />
      <Button className="mt-1 me-2" onClick={toggleRightCanvasT} color="warning">
        <i className="fa-solid fa-pen-to-square"></i>
      </Button>
      <Offcanvas
        style={{ width: "40%", border: "none" }}
        autoFocus
        direction="end"
        isOpen={open}
        toggle={toggleRightCanvasFS}
        fade
        className="fade"
      >
        <OffcanvasHeader style={{ background: "#2a3042", color: "white" }}>
          <i className="fa-solid fa-plus"></i>{" "}
          รายละเอียดกำหนดการรักษาราชการแทน
          <div className="position-absolute top-0 end-0">
            <i
              className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4"
              style={{ cursor: "pointer" }}
              onClick={toggleRightCanvasFS}
            ></i>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
              <LoadingData />
            </div>
          ) : (
            <Form onSubmit={e => { e.preventDefault(); setconfirmModal(true); }}>
              <Row>
                <Col lg={12}>
                  <FormGroup>
                    <Label>ผู้รับมอบอำนาจ</Label>
                    <InputGroup>
                      <Input
                        disabled
                        defaultValue={userName}
                        name="user_name"
                        placeholder=""
                        type="text"
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <FormGroup>
                    <Label>สำนัก/กอง/กลุ่ม ที่ได้รับการดูแล</Label>
                    <InputGroup>
                      <Input
                        readOnly
                        value={orgName ?? editOrgName}
                        name="org_name"
                        placeholder=""
                        type="text"
                      />
                      <ModalConID task="สำนัก/กอง/กลุ่ม_ผู้บังคับบัญชา" taskFilter="NEED_ADMINISTER" />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              {userEditData.map((edit, index) => {
                return (
                  <div key={index}>
                    <Row>
                      <Col lg={6}>
                        <FormGroup>
                          <Label>คำสั่งการมอบหมายตำแหน่งข้าราชการแทน</Label>
                          <br />
                          <Button className="" type="button" onClick={handleButtonFileClick}>
                            <i className="fa-solid fa-upload"></i>อัพโหลดไฟล์
                          </Button>
                          <input
                            id="file-input"
                            type="file"
                            accept=".pdf*"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                        </FormGroup>
                        {EditFile !== null && fileUp === null ? (
                          <Row className="mb-2">
                            <Col lg={12}>
                              <Alert color="success">
                                <Row className="align-items-center">
                                  <Col className="col-auto">
                                    <i className="fa-solid fa-file-pdf fa-2xl fa-beat" style={{ color: "#07e449" }}></i>
                                  </Col>
                                  <Col>
                                    <a href={`${API_URL}/${EditFile}`} target="_blank" className="text-muted font-weight-bold" rel="noreferrer">
                                      <p className="mb-0">
                                        <strong className="text-success">ไฟล์ที่อัพโหลด</strong>
                                      </p>
                                    </a>
                                  </Col>
                                </Row>
                              </Alert>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                        {fileUp !== null ? (
                          <Row className="mb-2">
                            <Col lg={12}>
                              <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <i className="fa-solid fa-file-pdf fa-2xl fa-beat" style={{ color: "#f81212" }}></i>
                                    </Col>
                                    <Col>
                                      <span className="text-muted font-weight-bold">{fileUp.name}</span>
                                      <p className="mb-0">
                                        <strong>{fileUp.formattedSize}</strong>
                                      </p>
                                    </Col>
                                    <Col className="col-auto">
                                      <button type="button" className="btn btn-link btn-sm text-danger" onClick={handleClearFile}>
                                        <i className="fa-solid fa-xmark-large"></i>
                                      </button>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                      </Col>
                      <br />
                      <Col lg={6}>
                        <InputGroup className="my-2">
                          <Input
                            placeholder="Check it out"
                            defaultValue="ใช้งาน"
                            style={{ cursor: "pointer", transition: "background-color 0.3s" }}
                          />
                          <InputGroupText>
                            <Input
                              addon
                              defaultChecked={edit.status === 1}
                              type="checkbox"
                              name="status"
                              onChange={e => setStatus(e.target.checked ? 1 : 0)}
                            />
                          </InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <FormGroup>
                          <Label>วันที่เริ่ม</Label>
                          <MyThaiDatePick
                            defaultValue={edit.date_start}
                            placeholderText="เลือกวันที่เริ่มต้น..."
                            setProbsDate={setStartDate}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup>
                          <Label>วันที่สิ้นสุด</Label>
                          <MyThaiDatePick
                            minDate={startDate}
                            defaultValue={edit.date_end}
                            placeholderText="เลือกวันที่สิ้นสุด..."
                            setProbsDate={setEndDate}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                );
              })}

              <br />
              <Row>
                <Col md={4} lg={6} xl={6}></Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} style={{ display: "flex", justifyContent: "end" }}>
                  <Button type="submit" color="success" style={{ width: "100%" }}>
                    บันทึก
                  </Button>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} style={{ display: "flex", justifyContent: "end" }}>
                  <Button color="danger" style={{ width: "100%" }} onClick={toggleRightCanvasFS}>
                    ยกเลิก
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </OffcanvasBody>
      </Offcanvas>
    </Fragment>
  );
}

export default EditAssignCommander;
